import { colors } from "@/styles/colors"

export const unusedHandlersAnimation = {
	"@keyframes pulse": {
		from: {
			boxShadow: `0px 0px 0 0px ${colors.yellow[500]}`
		},
		to: {
			boxShadow: `0px 0px 0 10px ${colors.yellow[100]}00`
		}
	},
	animation: {
		boxShadow: `0px 0px 1px 1px ${colors.yellow[500]}`,
		animation: "$pulse 2s infinite"
	}
}
